export const FREEAGENT_APP_ORIGIN =
  process.env.REACT_APP_FA_APP_ORIGIN || 'https://keystoneglazingltd.freeagent.com';

export function toFreeAgentInvoiceAppUrl(apiOrAppUrl?: string | null): string | undefined {
  const raw = String(apiOrAppUrl || '').trim();
  if (!raw) return undefined;
  const match = raw.match(/\/invoices\/(\d+)/i);
  if (!match) return raw;
  return `${FREEAGENT_APP_ORIGIN.replace(/\/+$/, '')}/invoices/${match[1]}`;
}

export function toFreeAgentBillAppUrl(apiOrAppUrl?: string | null): string | undefined {
  const raw = String(apiOrAppUrl || '').trim();
  if (!raw) return undefined;
  const match = raw.match(/\/bills\/(\d+)/i);
  if (!match) return raw;
  return `${FREEAGENT_APP_ORIGIN.replace(/\/+$/, '')}/bills/${match[1]}`;
}
